<template>
  <el-card class="creative" :body-style="{ padding: '0' }">
    <div slot="header" class="header">
      <span> {{ $t('CampaignForm_InApp_Button_Title') }} {{ index + 1 }} </span>
      <i v-if="onDelete" class="delete-btn el-icon-delete" @click="onDelete" />
    </div>
    <div class="body">
      <form-item prop="enabled" v-if="enableCheckbox">
        <checkbox
          v-model="value.enabled"
          title=""
          true-label="on"
          false-label="off"
          data-qa="inapp-btn-checkbox"
        />
      </form-item>
      <form-item
        prop="title"
        :label="$t('CampaignForm_InApp_Field_Text')"
        v-if="text"
      >
        <el-input v-model="value.text" data-qa="inapp-btn-text-input" />
      </form-item>
      <form-item
        v-if="activeTab"
        prop="prop"
        :label="$t('CampaignForm_InApp_Field_Upload')"
      >
        <campaign-image-upload
          class="upload"
          :value="value[activeTab].background_file"
          :file.sync="value[activeTab].background_file"
          :message-type="channelTypes.inapp"
          upload-type="fullsize"
          size="small"
        />
      </form-item>
      <form-item prop="action" :label="$t('CampaignForm_InApp_Field_Action')">
        <enum-select
          v-model="value.action"
          :options="availableActionLabels"
          data-qa="inapp-btn-action-dropdown"
        />
      </form-item>
      <form-item
        v-if="value.action === actionTypes.DEEPLINK"
        prop="deeplink"
        :label="$t('CampaignForm_InApp_Field_Deeplink')"
      >
        <el-input v-model="value.deeplink" data-qa="inapp-btn-deeplink-input" />
      </form-item>
      <form-item
        v-if="value.action === actionTypes.URL"
        prop="url"
        :label="$t('CampaignForm_InApp_Field_Url')"
      >
        <el-input v-model="value.url" data-qa="inapp-btn-url-input" />
      </form-item>

      <form-item prop="special" :label="$t('CampaignForm_InApp_Field_Save')">
        <enum-select
          v-model="value.special"
          :options="specialLabels"
          data-qa="inapp-btn-save-dropdown"
        />
      </form-item>
      <form-item
        class="p-top-8"
        v-if="value.special && value.special !== 'none'"
      >
        <el-row v-if="value.special === 'set_attribute'">
          <el-col :span="12">
            <el-autocomplete
              v-model="value.set_attribute.name"
              :fetch-suggestions="querySearchAttrs"
              :popper-options="popperOptions"
              data-qa="inapp-btn-attr-search-input"
            />
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="value.set_attribute.value"
              data-qa="inapp-btn-attr-value-input"
            />
          </el-col>
        </el-row>
        <el-select
          v-if="value.special === 'add_to_list'"
          v-model="value.add_to_list"
          filterable
          remote
          :remote-method="fetchUserListsRemote"
          :loading="userListLoading"
          data-qa="inapp-btn-list-input"
        >
          <el-option
            v-for="item in userListOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="value.special === 'subscribe_to'"
          v-model="value.subscribe_to"
          filterable
          remote
          :remote-method="fetchListsRemote"
          :loading="listLoading"
          data-qa="inapp-btn-subscribe-input"
        >
          <el-option
            v-for="item in listOptions"
            :key="item.id"
            :label="`${item.name} (${item.channel})`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </form-item>

      <form-item prop="trigger" :label="$t('CampaignForm_InApp_Field_Trigger')">
        <enum-select
          v-model="value.trigger"
          :options="triggerLabels"
          data-qa="inapp-btn-trigger-dropdown"
        />
      </form-item>
      <form-item class="p-top-8" v-if="value.trigger === 'trigger_event'">
        <el-autocomplete
          v-model="value.trigger_event"
          :fetch-suggestions="querySearchEvents"
          :popper-options="popperOptions"
          data-qa="inapp-btn-trigger-input"
        />
      </form-item>
    </div>
  </el-card>
</template>

<script>
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import FormItem from '@/common/components/form/FormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import {
  actionTypes,
  specialLabels,
  triggerLabels,
  actionLabels as defaultActionLabels
} from '@/modules/campaign-manage/enum/InAppTypesEnum'
import Checkbox from '@/common/components/form/Checkbox'
import { projectEndpoint, querySearch } from '@/core/helpers'
import CampaignImageUpload from '@/modules/campaign-manage/components/content/CampaignImageUpload'
import RestApi from '@/core/services/RestApi'
export default {
  name: 'InAppButton',
  components: {
    CampaignImageUpload,
    Checkbox,
    EnumSelect,
    FormItem
  },
  mounted() {
    this.fetchListsRemote()
    this.fetchUserListsRemote()

    // Parse values from the old UI
    if (this.value.add_to_list) {
      this.value.add_to_list = parseInt(this.value.add_to_list) || null
    }
    if (this.value.subscribe_to) {
      this.value.subscribe_to = parseInt(this.value.subscribe_to) || null
    }
  },
  data() {
    return {
      listLoading: false,
      userListLoading: false,
      listOptions: [],
      userListOptions: [],
      channelTypes,
      actionTypes,
      specialLabels,
      triggerLabels,
      popperOptions: {
        modifiers: [
          'preventOverflow',
          'flip',
          'offset',
          'keepTogether',
          'arrow',
          this.hidePopover,
          'applyStyle'
        ]
      }
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      required: true
    },
    onDelete: {
      required: false,
      default: null
    },
    activeTab: {
      required: false,
      default: null
    },
    text: {
      type: Boolean,
      default: true
    },
    enableCheckbox: {
      type: Boolean,
      default: true
    },
    actionLabels: {
      type: Object,
      default: null
    }
  },
  computed: {
    availableActionLabels() {
      return this.actionLabels || defaultActionLabels
    }
  },
  methods: {
    hidePopover(data) {
      const refRect = data.offsets.reference
      const windowHeight = window.innerHeight
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64
      data.styles.display =
        refRect.bottom - headerHeight < 0 || refRect.top > windowHeight
          ? 'none'
          : 'block'
      return data
    },
    querySearchAttrs(queryString, cb) {
      return querySearch(`tags`, { sort: 'title', title: queryString }, cb)
    },
    fetchListsRemote(queryString) {
      this.listLoading = true
      return RestApi(
        projectEndpoint({
          method: 'get',
          url: `subscription-preferences`,
          params: { sort: 'name', name: queryString }
        })
      )
        .then(({ data }) => {
          this.listOptions = data
          this.listLoading = false
        })
        .catch(error => {
          this.listLoading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    fetchUserListsRemote(queryString) {
      this.userListLoading = true
      return RestApi(
        projectEndpoint({
          method: 'get',
          url: `lists`,
          params: {
            sort: 'name',
            name: queryString,
            identifier: ['profile_id', 'device_id']
          }
        })
      )
        .then(({ data }) => {
          this.userListOptions = data
          this.userListLoading = false
        })
        .catch(error => {
          this.userListLoading = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    querySearchEvents(queryString, cb) {
      return querySearch(`events`, { sort: 'title', title: queryString }, cb)
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-card__header {
  padding: 16px;
  border-bottom: none;
}
.creative {
  background-color: #f8fafc;
  border: 1px solid #dbdee7;
  margin: 10px;
  box-shadow: none;
  .header {
    border-bottom: none;
    .delete-btn {
      float: right;
      padding: 3px 0;
      cursor: pointer;
      font-size: 16px;
      color: #a7acba;
    }
    span {
      font-weight: 600;
      font-size: 14px;
    }
  }
  .body {
    padding: 0 16px 16px;
    .upload {
      width: 100%;
      /deep/ .el-upload {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/InAppButton.vue